exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collapsed > .when-open,\n.not-collapsed > .when-closed {\n  display: none;\n}\n.editr table td {\n  height: 40px !important;\n}\n", ""]);

// exports
